@let _qaaPrefix = qaaPrefix();
@let _headerTimerEnabled = headerTimerEnabled();
<ng-container>
  <c-container [fluid]="true">
    <button
      toggle="visible"
      cHeaderToggler
      [cSidebarToggle]="sidebarId"
      class="ps-1"
      [attr.data-qaa]="_qaaPrefix + '-sidebar-toggle-button'"
    >
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>
    <c-header-nav class="ms-3">
      @if (_headerTimerEnabled) {
        <app-header-timer class="me-2" />
      }
      @if (currentAccount?.notificationByApp) {
        <div
          ngbDropdown
          #notificationBoard="ngbDropdown"
          [attr.data-qaa]="_qaaPrefix + '-notifications-dropdown'"
          (mouseenter)="$event.stopPropagation(); notificationBoard.open()"
          (mouseleave)="$event.stopPropagation(); notificationBoard.close()"
        >
          <a
            ngbDropdownAnchor
            class="btn nav-link position-relative"
            role="button"
            [routerLink]="['/app-notification']"
            [attr.data-qaa]="_qaaPrefix + '-notifications-link'"
          >
            <i class="feather-bell font-22"></i>
            @if (unreadUserAppNotificationsCount) {
              <span
                class="position-absolute badge-position translate-middle badge rounded-pill bg-danger"
                [attr.data-qaa]="_qaaPrefix + '-notifications-unread-badge'"
              >
                {{
                  unreadUserAppNotificationsCount < 100
                    ? unreadUserAppNotificationsCount
                    : "99+"
                }}
                <span class="visually-hidden">unread in-app notifications</span>
              </span>
            }
          </a>
          <div
            ngbDropdownMenu
            [class.d-none]="!userAppNotifications.length"
            class="dropdown-menu dropdown-menu-end m-0"
            [attr.data-qaa]="_qaaPrefix + '-notifications-menu'"
          >
            @for (
              userAppNotification of userAppNotifications;
              track userAppNotification.id
            ) {
              <a
                ngbDropdownItem
                (click)="openNotificationDetailModal(userAppNotification)"
                [class.bold]="!userAppNotification.readFlag"
                class="dropdown-item text-truncate mw-400"
                href="javascript:void(0)"
                [attr.data-qaa]="_qaaPrefix + '-notifications-menu-item'"
                [attr.data-qaa-id]="userAppNotification.id"
              >
                {{ userAppNotification.title }}
              </a>
            }
          </div>
        </div>
      }
      @if (showClientMessages) {
        <a
          [routerLink]="['/client-message']"
          class="btn nav-link position-relative"
          [attr.data-qaa]="_qaaPrefix + '-client-messages-link'"
        >
          <i class="feather-mail font-22"></i>
          @if (unreadMessagesCount$ | async; as unreadMessagesCount) {
            <span
              class="position-absolute badge-position translate-middle badge rounded-pill bg-danger"
              [attr.data-qaa]="_qaaPrefix + '-client-messages-unread-badge'"
            >
              {{ unreadMessagesCount < 100 ? unreadMessagesCount : "99+" }}
              <span class="visually-hidden">unread messages</span>
            </span>
          }
        </a>
      }
      <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
    </c-header-nav>
  </c-container>
  <c-header-divider></c-header-divider>
  <c-container [fluid]="true">
    @if (!hidenav && currentAccount) {
      <app-breadcrumb [data-qaa]="_qaaPrefix + '-breadcrumb'"></app-breadcrumb>
    }
  </c-container>
</ng-container>

<ng-template #userDropdown>
  @let _qaaPrefix = qaaPrefix();
  <ul class="nav navbar-nav ms-auto">
    <li class="nav-item me-3" ngbDropdown>
      <button
        (click)="(false)"
        class="nav-link outline-0 btn"
        ngbDropdownToggle
        [attr.data-qaa]="_qaaPrefix + '-user-menu-button'"
      >
        @if (currentAccount) {
          <span class="d-none d-sm-inline"
            >{{ currentAccount?.firstName }}
            {{ currentAccount?.lastName }}</span
          >
        }
        &nbsp; <i class="feather-settings"></i>
      </button>

      <div
        ngbDropdownMenu
        class="mt-2"
        [attr.data-qaa]="_qaaPrefix + '-user-menu'"
      >
        <a
          [routerLink]="['/settings']"
          class="dropdown-item"
          [attr.data-qaa]="_qaaPrefix + '-user-menu-profile-link'"
          ><i class="feather-user"></i> Profile</a
        >
        @if (
          currentAccount?.firmSettings?.emailSyncProvider === "O365" &&
          !currentUserIsLimitedAccess
        ) {
          <a
            ngbDropdownItem
            [routerLink]="['/system/integrations/office365']"
            [attr.data-qaa]="_qaaPrefix + '-user-menu-office365-sync-link'"
            ><i class="feather-refresh-cw"></i> Office 365 Sync</a
          >
        }
        @if (
          currentAccount?.firmSettings?.emailSyncProvider === "GMAIL" &&
          !currentUserIsLimitedAccess
        ) {
          <a
            [routerLink]="['/system/integrations/google']"
            class="dropdown-item"
            [attr.data-qaa]="_qaaPrefix + '-user-menu-google-email-sync-link'"
            ><i class="feather-refresh-cw"></i> Google Email Sync</a
          >
        }
        @if (
          currentAccount?.rightsignatureEnabled && !currentUserIsLimitedAccess
        ) {
          <a
            [routerLink]="['/system/integrations/rightsignature']"
            class="dropdown-item"
            [attr.data-qaa]="_qaaPrefix + '-user-menu-rightsignature-link'"
            ><i class="feather-refresh-cw"></i> Right Signature</a
          >
        }
        @if (currentAccount?.filesyncEnabled && !currentUserIsLimitedAccess) {
          <a
            [routerLink]="['/system/integrations/filesync']"
            class="dropdown-item"
            [attr.data-qaa]="_qaaPrefix + '-user-menu-filesync-link'"
            ><i class="feather-refresh-cw"></i> FileSync</a
          >
        }
        <a
          [routerLink]="['/password']"
          class="dropdown-item"
          [attr.data-qaa]="_qaaPrefix + '-user-menu-change-password-link'"
          ><i class="feather-lock"></i> Change Password</a
        >
        <a
          href="https://firm360.zendesk.com/hc/en-us/"
          target="_blank"
          class="dropdown-item"
          [attr.data-qaa]="_qaaPrefix + '-user-menu-user-manual-link'"
          ><i class="feather-help-circle"></i> User Manual</a
        >
        @if (
          !currentAccount?.firmSettings?.adminOnlyMessageTemplates &&
          showClientMessages
        ) {
          <a
            [routerLink]="[
              '/system/customizations/client-message-template/user',
            ]"
            class="dropdown-item"
            [attr.data-qaa]="_qaaPrefix + '-user-menu-message-templates-link'"
            ><i class="feather-file-text"></i> My Message Templates</a
          >
        }

        <button
          (click)="logout()"
          ngbDropdownItem
          [attr.data-qaa]="_qaaPrefix + '-user-menu-logout-button'"
        >
          <i class="feather-arrow-left"></i> Logout
        </button>
      </div>
    </li>
  </ul>
</ng-template>
